// extracted by css-extract-rspack-plugin
export default {"cls1":"PingAnswerStyles-cls1_X8_","cls2":"PingAnswerStyles-cls2_4P- PingAnswerStyles-cls1_X8_"};